import styled from 'styled-components';

// Colors
import * as colors from '@drivesally/sally-ui/lib/libs/colors';

// Constants
import statusColor from './statusColor.const';

const IconBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: ${({status}) => colors[statusColor[status]] || colors.mediumBlueGrey};
  color: ${colors.white};
  font-size: 13px;
`;

export default IconBadge;
